import React, { useState } from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate
} from 'react-router-dom';

import EventList from './components/EventList';
import AdminPage from './components/AdminPage';
import LoginPage from './components/LoginPage';

function App() {
  const [token, setToken] = useState(localStorage.getItem('token') || '');
  const [showModal, setShowModal] = useState(true);

  const handleLogout = () => {
    localStorage.removeItem('token');
    setToken('');
  };

  return (
    <Router>
      <div
  style={{
    minHeight: '100vh',
    backgroundImage: 'url("/images/bg-pattern.png")',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto',
    backgroundAttachment: 'fixed',
  }}
>
        {/* 使用說明彈窗 */}
        {showModal && (
          <div
            className="modal-backdrop d-flex justify-content-center align-items-center"
            style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              zIndex: 9999,
            }}
          >
            <div
              className="bg-white p-4 rounded-lg shadow-lg"
              style={{ zIndex: 10000, maxWidth: '500px', width: '90%', padding: '2rem' }}
            >
              <h2 className="text-center text-primary mb-4">預約系統使用說明</h2>
              <ul className="list-unstyled">
                <li className="mb-3">
                  <span style={{ fontWeight: 'bold' }}>活動開始前一天零晨00:00 ~ 開始前2小時 可進行預約</span>
                  <br />
                  <span style={{ color: '#006400' }}>
                    Reservations open at 12:00 a.m. the day before the activity and close two hours before it begins.
                  </span>
                </li>
                <li className="mb-3">
                  <span style={{ fontWeight: 'bold' }}>同一學期內，同學若達兩次違規紀錄，將被列入黑名單兩週。違規行為包括預約成功卻未到(活動於12:10開始，請同學務必在12:10前報到入座)，或活動中無正當理由中途離席。</span>
                  <br />
                  <span style={{ color: '#006400' }}>
                    Students who commit two violations in the same semester will be blacklisted for two weeks. Violations include no-shows and leaving early without a valid reason. (students must check in and be seated before 12:10 PM)
                  </span>
                </li>
                <li className="mb-3">
                  <span style={{ fontWeight: 'bold' }}>若需要取消預約，請點擊【搜尋預約紀錄】，輸入姓名學號信箱刪除紀錄</span>
                  <br />
                  <span style={{ color: '#006400' }}>
                    To cancel your reservation, please click "Check Your Reservation", and enter your name, student ID, and email to delete the record.
                  </span>
                </li>
              </ul>
              <button
                className="btn btn-primary w-100"
                onClick={() => setShowModal(false)}
                style={{ fontWeight: 'bold', fontSize: '1.1rem' }}
              >
                我知道了 Noted
              </button>
            </div>
          </div>
        )}

        {/* 導覽列 */}
        <div className="container mt-4">
<nav className="d-flex align-items-center mb-3">
  <a
    href="https://emicenter.siwan.nsysu.edu.tw/"
    target="_blank"
    rel="noopener noreferrer"
  >
    <img
      src="/EMILEGO.png"
      alt="中心Logo"
      style={{
        height: '100px',
        objectFit: 'contain',
        marginRight: '1rem',
        cursor: 'pointer',
        backgroundColor: 'transparent', // 強制背景透明
        mixBlendMode: 'multiply'
      }}
    />
  </a>
</nav>

          {/* 路由設定 */}
          <Routes>
            <Route path="/" element={<EventList />} />
            <Route
              path="/login"
              element={
                <LoginPage
                  onLoginSuccess={(newToken) => {
                    setToken(newToken);
                    localStorage.setItem('token', newToken);
                  }}
                />
              }
            />
            <Route
              path="/admin"
              element={
                token ? (
                  <AdminPage token={token} onLogout={handleLogout} />
                ) : (
                  <Navigate to="/login" replace />
                )
              }
            />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
